module.exports = __webpack_public_path__ + "img/708-dd22dd.png";